// ** Redux Imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from "axios"

import { EXPENSES } from "../../../../../../../../../utility/SourceAPI"
import {
    formattedDateTimePicker,
    minutes,
    seconds,
    miliseconds,
    formattedDatePicker
} from "../../../../../../../../../utility/formats/formattedDate"

export const getExpenses = createAsyncThunk('appExpenses/getExpenses', async (data) => {
    const response = await axios.get(data.rangeDates !== undefined ? EXPENSES.concat(`?intermediary_id=${data.id}`).concat(`&end=${formattedDatePicker(data.rangeDates.end)} 23:${minutes}:${seconds}.${miliseconds}&start=${formattedDateTimePicker(data.rangeDates.start)}`) : EXPENSES.concat(`?intermediary_id=${data.id}`))
    return {
        data: response.data
    }
})

export const getHistoryExpenses = createAsyncThunk('appExpenses/getHistoryExpenses', async (data) => {
    const response = await axios.get(data.rangeDates !== undefined ? EXPENSES.concat(`?history=true`).concat(`&end=${formattedDatePicker(data.rangeDates.end)} 23:${minutes}:${seconds}.${miliseconds}&start=${formattedDateTimePicker(data.rangeDates.start)}`) : EXPENSES.concat(`?history=true`))
    return {
        data: response.data
    }
})

export const getExpensesToRelease = createAsyncThunk('appExpenses/getExpensesToRelease', async () => {
    const response = await axios.get(EXPENSES.concat(`?is_deleteable=true`))
    return {
        data: response.data
    }
})

export const newExpense = createAsyncThunk('appExpenses/addExpense', async (expense, { dispatch }) => {
    const response = await axios.post(EXPENSES, expense)
    await dispatch(getExpenses())
    return response.data
})

export const addInvoiceExpense = createAsyncThunk('appExpenses/addInvoiceExpense', async (expense, { dispatch }) => {
    const response = await axios.put(EXPENSES.concat('linked-cfdi/'), expense)
    await dispatch(getExpenses())
    return response.data
})

export const deleteExpense = createAsyncThunk('appExpenses/deleteExpense', async (id, { dispatch }) => {
    const response = await axios.delete(EXPENSES.concat(`${id}`))
    await dispatch(getExpenses())
    return response.data
})

export const requestExpenseDeletion = createAsyncThunk('appExpenses/requestExpenseDeletion', async (data, { dispatch }) => {
    const response = await axios.put(`${EXPENSES}is_deleteable/${data.id}`, {
        raison_deleted: data.raison_deleted
    })
    await dispatch(getExpenses())
    return response.data
})

export const authorizeExpenseDeletion = createAsyncThunk('appExpenses/authorizeExpenseDeletion', async (data, { dispatch }) => {
    const response = await axios.put(`${EXPENSES}authorize-deleted/${data.id}?authorized_deleted=${data.authorized_deleted}`)
    await dispatch(getExpensesToRelease())
    return response.data
})

export const appExpensesSlice = createSlice({
    name: 'appExpenses',
    initialState: {
        data: [],
        dataToRelease: [],
        historyExpenses: []
    },
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getExpenses.fulfilled, (state, action) => {
            state.data = action.payload.data
        })
        builder.addCase(getExpensesToRelease.fulfilled, (state, action) => {
            state.dataToRelease = action.payload.data
        })
        builder.addCase(getHistoryExpenses.fulfilled, (state, action) => {
            state.historyExpenses = action.payload.data
        })
    }
})

export default appExpensesSlice.reducer